var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c("b-table", {
                ref: "rewards",
                staticClass: "mb-0",
                attrs: {
                  id: "rewards",
                  selectable: "",
                  "select-mode": "single",
                  selectedVariant: "success",
                  striped: "",
                  small: "",
                  "thead-class": "top-fixed-thead thead-light",
                  "table-class": "text-small",
                  responsive: "",
                  "show-empty": "",
                  "empty-text": _vm.$t("message.common.emptyTable"),
                  busy: _vm.isBusy,
                  items: _vm.items,
                  fields: _vm.fields,
                  "no-provider-filtering": "",
                  "no-provider-paging": "",
                  "no-provider-sorting": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-success my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Загрузка")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(date)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTableDate(row.item.date)) +
                            "\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(type_id)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getTypeName(row.item.type_id)) +
                            "\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(summa)",
                    fn: function(row) {
                      return [
                        _c(
                          "span",
                          { class: _vm.getSignForType(row.item.type_id).class },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getSignForType(row.item.type_id).symbol +
                                    " " +
                                    row.item.summa
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(period)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTableDate(row.item.start_date)) +
                            " - " +
                            _vm._s(_vm.formatTableDate(row.item.end_date)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination-footer", {
            attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
            on: {
              "update:perPage": function($event) {
                _vm.perPage = $event
              },
              "update:per-page": function($event) {
                _vm.perPage = $event
              },
              "page-click": _vm.onPagination
            },
            scopedSlots: _vm._u([
              {
                key: "footer-buttons",
                fn: function() {
                  return [
                    _c("b-pagination", {
                      attrs: {
                        pills: "",
                        "per-page": _vm.perPage,
                        "total-rows": _vm.totalRows
                      },
                      on: { "page-click": _vm.onPagination },
                      model: {
                        value: _vm.currentPage,
                        callback: function($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06216632", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06216632","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserRewards.vue
// module id = null
// module chunks = 